module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "admin-menu"
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "margin-top": "-5.2em"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]) : _c('div', {
    staticClass: "sidebar-secondary-admin"
  }, [_c('div', {
    staticClass: "toggle-btn",
    staticStyle: {
      "margin-top": "-4.7em",
      "position": "absolute"
    }
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), _c('ul', [_c('li', {
    class: {
      active: _vm.isActive('/dashboard')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Reports & Analytics")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/profile')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Profile")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Manage Your Aaccount")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/contracts')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/contracts"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Contracts "), (_vm.notifications_contracts != 0) ? _c('span', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.notifications_contracts))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Contracts")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/business-listings')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "business-listings"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-suitcase",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Business Listings")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Business Listings")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/survey-requests')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/survey-requests"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-credit-card",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("CNsurveys"), (_vm.notifications_cnsurveys != 0) ? _c('span', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.notifications_cnsurveys))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Surveys Requests")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/cnpro-accounts')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/cnpro-accounts"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("CNpro Accounts "), (_vm.notifications_cnpros != 0) ? _c('span', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.notifications_cnpros))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Service Listings")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/saved-listings')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/saved-listings"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-bookmark",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Saved Listings")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("View Them Again")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/mymoney')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/mymoney"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("My Money")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Payouts")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/cnwallet')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/cnwallet"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Rewards")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Rewards")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/cnpaytransactions')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/cnpaytransactions"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("CNpay Transactions")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Transactions")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/account-cninsurance')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/account-cninsurance"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-table",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("InsureMoto")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Your Insurance Packages")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/myreferrals')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/myreferrals"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("My Referrals")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("People you referred")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActive('/login')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-power-off",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Log Out")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("sign out from account")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c8feb6f"}!./src/components/Dashboard-Sidebar/template.html
// module id = 308
// module chunks = 0